import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './EmailVerification.css';
import { Button } from './shared';

function EmailVerification({ onBackToLogin }) {
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('E-Mail wird verifiziert...');
  const [email, setEmail] = useState('');
  const [resending, setResending] = useState(false);
  const [resendCount, setResendCount] = useState(0);

  useEffect(() => {
    // Get token from URL query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Kein Verifizierungstoken gefunden. Bitte überprüfe den Link in deiner E-Mail.');
      return;
    }

    // Call verify-email API
    axios.post('/api/verify-email', { token })
      .then(response => {
        setStatus('success');
        setMessage(response.data.message);
      })
      .catch(error => {
        setStatus('error');
        if (error.response && error.response.data) {
          setMessage(error.response.data.message);
        } else {
          setMessage('Fehler bei der Verifizierung. Bitte versuche es später erneut.');
        }
      });
  }, []);

  const handleResendVerification = () => {
    if (!email || email.trim() === '') {
      alert('Bitte gib deine E-Mail-Adresse ein.');
      return;
    }

    // Check if already at max resends
    if (resendCount >= 3) {
      alert('Du hast das Limit für Wiederholungen erreicht. Bitte kontaktiere unseren Kundenservice unter kundenservice@universe-app.de');
      return;
    }

    setResending(true);

    axios.post('/api/resend-verification', { email })
      .then(response => {
        setResendCount(resendCount + 1);
        alert(response.data.message);
        setResending(false);
      })
      .catch(error => {
        setResending(false);
        if (error.response) {
          // If we get a 429 (TooManyRequests) error, set resend count to 3
          if (error.response.status === 429) {
            setResendCount(3);
          }
          if (error.response.data) {
            alert(error.response.data.message);
          } else {
            alert('Fehler beim Senden der E-Mail. Bitte versuche es später erneut.');
          }
        } else {
          alert('Fehler beim Senden der E-Mail. Bitte versuche es später erneut.');
        }
      });
  };

  return (
    <div className="verification-container">
      <div className="verification-box">
        <h1>E-Mail-Verifizierung</h1>

        <div className={`verification-status ${status}`}>
          {status === 'loading' && (
            <div className="spinner"></div>
          )}
          {status === 'success' && (
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
              <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          )}
          {status === 'error' && (
            <svg className="error-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle className="error-circle" cx="26" cy="26" r="25" fill="none"/>
              <path className="error-line" fill="none" d="M16 16 36 36 M36 16 16 36"/>
            </svg>
          )}
        </div>

        <p className="verification-message">{message}</p>

        {status === 'success' && (
          <Button variant="primary" onClick={onBackToLogin}>
            Zur Anmeldung
          </Button>
        )}

        {status === 'error' && (
          <div className="resend-section">
            <p className="resend-text">Token abgelaufen? Fordern Sie einen neuen an:</p>
            <input
              type="email"
              placeholder="Ihre E-Mail-Adresse"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="resend-input"
            />
            <Button
              variant="secondary"
              onClick={handleResendVerification}
              disabled={resending || resendCount >= 3}
            >
              {resending ? 'Wird gesendet...' : 'Neue Verifizierungs-E-Mail senden'}
            </Button>
            {resendCount >= 3 && (
              <p className="resend-limit-message">
                Sie haben das Limit für Wiederholungen erreicht. Bitte kontaktieren Sie unseren Kundenservice unter kundenservice@universe-app.de
              </p>
            )}
            <Button variant="link" onClick={onBackToLogin}>
              Zurück zur Anmeldung
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmailVerification;
